export const schemaCheck = function (schema, objectName) {
  //Test if object is empty
  if (Object.keys(schema).length === 0 && schema.constructor === Object) {
    return 0
  }

  if (objectName in schema && "sVersion" in schema[objectName]) {
    return schema[objectName].sVersion
  }

  return 0
}
